import { useSyncExternalStore } from "react";
import { createStore } from "./store.js";
const consentManagerStateStore = createStore({
  isErrorDrawerOpen: false
});
const useConsentManager = () => {
  const state = useSyncExternalStore(
    consentManagerStateStore.subscribe,
    consentManagerStateStore.getSnapshot,
    consentManagerStateStore.getSnapshot
  );
  return {
    state,
    openErrorDrawer: () => {
      consentManagerStateStore.setState({ isErrorDrawerOpen: true });
    },
    closeErrorDrawer: () => {
      consentManagerStateStore.setState({ isErrorDrawerOpen: false });
    }
  };
};
export {
  useConsentManager
};
